<script>
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [
    reactiveProp
  ],
  props: [
    // 'chartData',
    'options'
  ],
  mounted: function () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style scoped>
</style>
